import { API_BASE_URL, API_BASE_URL_RTS, API_BASE_URL_MP, API_BASE_URL_PETRO, BASE_URL, API_BASE_URL_PDSS } from ".";
const FRONTEND_URL = process.env.VUE_APP_FRONT_END_ADMIN;

console.log("FRONTEND_URL ", FRONTEND_URL);

// import {VUE_APP_API_BASE_URL , BASE_URL} from 
// const API_BASE_URL = "http://localhost:8082"

export const ENDPOINT = {
    PRINT : `${FRONTEND_URL}/admin/vessel`,
    //auth
    CREATE_USER: `${API_BASE_URL}/users/create-user`,
    CREATE_ADMIN: `${API_BASE_URL}/users/create-admin`,
    CREATE_SUPERVISOR: `${API_BASE_URL}/users/create-supervisor`,


    CREATE_USER_JURISTIC: `${API_BASE_URL}/users/create-user-juristic`,
    LOGIN_URL: `${API_BASE_URL}/auth/login`,

    //user
    GET_USER_BY_ID: `${API_BASE_URL}/users/get-user-by-id`,
    GET_USER_ALL: `${API_BASE_URL}/users/all`,
    GET_CONTRACTOR: `${API_BASE_URL}/users/all/contractor`,
    GET_USER_ADMIN: `${API_BASE_URL}/users/all/admin`,
    GET_OWNER: `${API_BASE_URL}/users/all/ownerList`,
    CREATE_COMPANY_SEAL: `${API_BASE_URL}/users/update-company-seal`,
    UPDATE_USER_STATUS: `${API_BASE_URL}/users/update-user-status`,
    UPDATE_USER: `${API_BASE_URL}/users/edit-user`,
    CREATE_OBSERVER: `${API_BASE_URL}/users/create-observer`,
    CREATE_CONTRACTOR: `${API_BASE_URL}/users/create-contractor`,
    GET_TEAM: `${API_BASE_URL}/users/team`,

    //registration_vessel
    GET_VESSELS: `${API_BASE_URL}/registration`,
    GET_VESSELS_BY_REGISTRATION_NUMBER: `${API_BASE_URL}/registration/get-vessel-by-registration-number`,
    CREATE_REGISTRATION_URL: `${API_BASE_URL}/registration/create/manual`,
    UPLOAD_FILE: `${API_BASE_URL}/registration/uploadFiles`,
    UPDATE_STATUS: `${API_BASE_URL}/registration/status`,
    GET_IMAGE: `${API_BASE_URL}/registration/photo/`,
    GET_IMAGE_INSTALL: `${API_BASE_URL}/installation/photo/`,
    GET_IMAGE_SIGNATURE: `${API_BASE_URL}/registration/photo/signature/`,
    GET_IMAGE_USER: `${API_BASE_URL}/registration/photo/users/`,
    GET_IMAGE_COMPANY_SEAL: `${API_BASE_URL}/registration/photo/users/`,
    CREATE_MMSI: `${API_BASE_URL}/registration/create/mmsi`,
    DOCUMENT: `${API_BASE_URL}/registration/document`,
    DELETE_DOCUMENT_INSTALL: `${API_BASE_URL}/installation/document`,

    // reparations_vessel
    GET_VESSEL_REPARATIONS:`${API_BASE_URL}/reparation`,
    GET_VESSEL_REPARATIONS_BY_ID: `${API_BASE_URL}/reparation/by-id`,
    GET_REPARATION_FOR_ACCESSORIES_RECEIVED: `${API_BASE_URL}/reparation/status/reparation`,
    CREATE_ACCESSORIES_REPARATION: `${API_BASE_URL}/accessoriesReceive/reparation`,
    CONFIRM_INSTALL_ACCESSORIES_REPARATION: `${API_BASE_URL}/installation/reparation/manual`,

    //Accessories
    CREATE_ACCESSORIES: `${API_BASE_URL}/installation`,
    CREATE_NEW_ACCESSORIES_REPARATION: `${API_BASE_URL}/installation/create-reparation-install`,
    UPDATE_ACCESSORIES : `${API_BASE_URL}/installation/update-accessories-registration`,
    UPDATE_INSTALLATION : `${API_BASE_URL}/installation/update-installation-registration`,

    //Install Accessories
    GET_REGISTRATION_FOR_INSTALL: `${API_BASE_URL}/installation/registration`,
    
    //select box vessel
    GET_PORT_NAME: `${API_BASE_URL}/registration/vessel/port-name`,
    GET_TOOL_TYPE: `${API_BASE_URL}/registration/vessel/tool-type`,
    GET_USAGE_TYPE: `${API_BASE_URL}/registration/vessel/usage-type`,
    GET_VESSEL_TYPE: `${API_BASE_URL}/registration/vessel/vessel-type`,
    GET_ZONE: `${API_BASE_URL}/registration/vessel/zone`,

    // vesssel Accessories
    GET_VESSEL_ACCESSORIES: `${API_BASE_URL}/accessoriesReceive`,
    CREATE_VESSEL_ACCESSORIES: `${API_BASE_URL}/accessoriesReceive`,

    //vessel
    UPDATE_VESSEL: `${API_BASE_URL}/registration/update-vessel-admin`,
    UPDATE_VESSEL_IMAGE: `${API_BASE_URL}/registration/update-vessel-image`,

    // otp
    REQUEST_OTP: `${API_BASE_URL}/otp/request-otp`,

    // resignation_vessel
    GET_VESSEL_RESIGNATIONS:`${API_BASE_URL}/resignation`,
    GET_VESSELS_STATUS:`${API_BASE_URL}/resignation/status`,
    CREATE_VESSEL_RESIGNATION_ADMIN:`${API_BASE_URL}/resignation/create/resignation-admin`,
    CREATE_VESSEL_RESIGNATION_USER:`${API_BASE_URL}/resignation/create/resignation-user`,
    UPDATE_RESIGNATION_STATUS:`${API_BASE_URL}/resignation/update`,

    //dashboard
    GET_NUMBER_OF_REGISTRATION: `${API_BASE_URL}/registration/number-of-registration`,
    GET_NUMBER_OF_RESIGNATION: `${API_BASE_URL}/resignation/number-of-resignation`,
    GET_NUMBER_OF_REPARATION: `${API_BASE_URL}/reparation/number-of-reparation`,


    //rts monitoring
    API_VESSEL_GROUPS: `${API_BASE_URL_RTS}/admin/vessel_groups`, //${id} = 1
    API_ADMIN_VESSEL_GROUP: `${API_BASE_URL_RTS}/admin/vessel_groups.json`,
    API_GET_ADMIN_VESSELS: `${API_BASE_URL_RTS}/admin/vessels.json`,
    API_GET_VESSELS: `${API_BASE_URL_RTS}/api/vessels.json`,
    RTS_VESSEL: `${API_BASE_URL}/rts/vessels`,
    RTS_ADMIN_VESSEL: `${API_BASE_URL}/rts/admin_vessels`,
    RTS_VESSEL_BY_SHIP_TYPE: `${API_BASE_URL}/rts/vessels_by_ship_type`,
    RTS_GET_BASE_STATIONS: `${API_BASE_URL}/rts/base_station`,
    RTS_GET_NAVIGA_STATUS: `${API_BASE_URL}/rts/navigation_statuses`,
    RTS_GET_SHIP_TYPE: `${API_BASE_URL}/rts/ship_types`,
    RTS_GET_GUARD_ZONE: `${API_BASE_URL}/rts/guard_zone`,
    RTS_GET_GUARD_ZONE_NOTIFICATION: `${API_BASE_URL}/rts/guard_zone_notifications`,
    RTS_GET_PROXIMITY_EVENTS: `${API_BASE_URL}/rts/proximity_events`,
    RTS_GET_REFUEL_REPORTS: `${API_BASE_URL}/rts/refuel_reports_all`,
    RTS_GET_REFUEL_REPORT: `${API_BASE_URL}/rts/refuel_reports`,
    RTS_GET_ฺBATTERY_STATUS_REPORT: `${API_BASE_URL}/rts/battery_status_reports`,
    RTS_GET_ฺAIS_LOSS_REPORT: `${API_BASE_URL}/rts/ais_loss_reports`,
    RTS_READ_GUARD_ZONE_NOTIFICATION: `${API_BASE_URL}/rts/read_guard_zone_notifications`,
    RTS_READ_ALL_GUARD_ZONE_NOTIFICATION: `${API_BASE_URL}/rts/read_all_guard_zone_notifications`,
    RTS_URL_VESSEL_HISTORIES: `${API_BASE_URL}/rts/url_vessel_histories`,
    RTS_VESSEL_HISTORIES: `${API_BASE_URL}/rts/vessel_histories`,
    RTS_URL_GET_VESSEL_TRACKING: `${API_BASE_URL}/rts/vessel_tracking`,
    RTS_GET_ZONES: `${API_BASE_URL}/rts/zones`,
    RTS_GET_VESSELS_BY_BASE_STATION: `${API_BASE_URL}/rts/vessels_by_base_station`,

    //notification
    GET_NOTIFICATION: `${API_BASE_URL}/notification`,
    SEND_NOTIFICATION: `${API_BASE_URL}/notification/send`,
    GET_NOTIFICATION_All: `${API_BASE_URL}/notification/all`,
    READ_NOTIFICATION_All: `${API_BASE_URL}/notification/read-all-web`,

    // signature
    CREATE_SIGNATURE_ADMIN: `${API_BASE_URL}/registration/create/signature`, // create signature by myself กรณีเซนต์ admin เซนต์เอง
    CREATE_SIGNATURE_BY_FILENAME: `${API_BASE_URL}/registration/create/signature-by-filename`, // create signature by get signature in user table ในการ admin มีลายเซนต์อยู่แล้ว
    CREATE_SIGNATURE_USER: `${API_BASE_URL}/users/create/signature`, // create signature in user tbale // ในกรณีที่ admin ยังไม่เซนต์เลย

    //Petrol
    VESSEL_TRIPS: `${API_BASE_URL}/petrol/vessel_trips`,
    PETROL_GET_OIL_TYPE: `${API_BASE_URL}/petrol/oil_types`,
    PETROL_GET_VESSELS: `${API_BASE_URL}/petrol/vessels`,
    PETROL_COUNTRIES: `${API_BASE_URL}/petrol/countries`,
    // GET_OIL_TRANSFERS: `${API_BASE_URL_PDSS}/petrol/vessel_trips`,

    //mp
    MP_TRANSFERS_LOGS: `${API_BASE_URL}/mp/transfer_logs`,
    MP_TRANSFERS: `${API_BASE_URL}/mp/transfers`,
    MP_STATIONS: `${API_BASE_URL}/mp/stations`,
    MP_TANKERS: `${API_BASE_URL}/mp/tankers`,
    // 
    MP_PROVINCES: `https://mp-new.excise-online.com/provinces.json`,
    MP_VESSELS: `${API_BASE_URL}/mp/vessels`,
    GET_OIL_PRICE: `${API_BASE_URL}/mp/oil-price`,
    MP_GET_OVER_FLOW_TRANSFER: `${API_BASE_URL}/mp/over_flow_transfer`,

    //pdss
    LAST_OIL_PRICE: `${API_BASE_URL_PDSS}/oil_price/find_one`,

    //flowMeter
    GET_OIL_TRANSFERS_FLOW_METER: 'http://flow_meter.excise-online.com/batch_logs.json',//`${API_BASE_URL}/test-api/oil-transfer-logs`,

};

export const PERSONTYPE = {
    OWNER: "บุคคลทั่วไป",
    JURISTIC: "นิติบุคคล"
}

export const SIGNATURE_TYPE = { 
    REGISTRATION: 1,
    ACCESSORIES_RECEIVE: 2,
    INSTALLATION: 3,
    REPARATION: 4,
    RESIGNATION: 5,
}
